import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-analysis-required-dialog',
    templateUrl: './analysis-required-dialog.component.html',
    styleUrls: ['./analysis-required-dialog.component.css'],
    standalone: false
})
export class AnalysisRequiredDialogComponent implements OnInit {

  dialogTitle: string = '';
  selectedLength: number = 0;
  totalSamples: number = 0;
  selectedOption: number = 1;
  dialogType: string = '';

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<AnalysisRequiredDialogComponent>
  ) {
  }

  ngOnInit(): void {
    this.dialogTitle = this.data.dialogTitle;
    this.selectedLength = this.data.selectedLength;
    this.totalSamples = this.data.totalSamples;
    this.dialogType = this.data.dialogType;
  }

  closeDialog(optionChosen: boolean) {
    this.dialogRef.close(optionChosen ? this.selectedOption : null);
  }
}
